import {
    SET_REP_FIRST_NAME, SET_REP_LAST_NAME,
    SET_REP_EMAIL, SET_REP_PHONE,
    SET_REP_ROLE,
    SET_SALES_REP,
} from './constants';

export const setSalesRep = rep => ({
    type: SET_SALES_REP,
    rep,
});
export const setRepFirstName = firstName => ({
    type: SET_REP_FIRST_NAME,
    firstName,
});

export const setRepLastName = lastName => ({
    type: SET_REP_LAST_NAME,
    lastName,
});

export const setRepEmail = email => ({
    type: SET_REP_EMAIL,
    email,
});

export const setRepPhone = phoneNumber => ({
    type: SET_REP_PHONE,
    phoneNumber,
});

export const setRepRole = role => ({
    type: SET_REP_ROLE,
    role,
});



// WEBPACK FOOTER //
// ./src/containers/common/projectreps/actions.js